<div class="toast-notification-container">
    @if (Icon) {
    <div class="toast-icon">
        <mat-icon>{{ Icon }}</mat-icon>
    </div>
    }
    <div class="content-wrapper">
        <span class="message">{{ data.message }}</span>
        @if (data.actionText && data.action) {
        <button
            mat-button
            (click)="data.action()"
            class="action-button"
        >
            {{ data.actionText }}
        </button>
        }
    </div>
    <div class="vertical-delimiter"></div>
    <button
        (click)="closeToast()"
        class="close-action"
        mat-icon-button
    >
        <mat-icon id="close_icon">close</mat-icon>
    </button>
</div>
